var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomeapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2,.cls-3{fill:#424aaa;}.cls-3{opacity:0.36;mix-blend-mode:multiply;}.cls-4{fill:#f8d2a1;}.cls-5{fill:#6565e0;}.cls-6{fill:#dfe6fe;}.cls-7{fill:#fff;}.cls-8{fill:#2c28dd;}.cls-9{fill:#ddbb8f;}.cls-10{fill:#db6b29;}.cls-11{fill:#3853f2;}.cls-12{fill:#dca07b;}.cls-13{fill:#cf9c84;}.cls-14{fill:#f6772e;}.cls-15{fill:#ebeff3;}.cls-16{fill:#43253d;}.cls-17,.cls-21,.cls-30,.cls-31{fill:none;}.cls-17{stroke:#43253d;stroke-width:0.61px;}.cls-17,.cls-21,.cls-30{stroke-miterlimit:10;}.cls-18{fill:#e6b54f;}.cls-19{fill:#f6c761;}.cls-20{fill:#872612;}.cls-21{stroke:#872612;}.cls-22{fill:#2e5388;}.cls-23{fill:#313b64;}.cls-24{fill:#608cce;}.cls-25{fill:#411919;}.cls-26{fill:#ff9c42;}.cls-27{fill:#3e689e;}.cls-28{fill:#77a6e4;}.cls-29{fill:#e6b397;}.cls-30{stroke:#a06ece;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "customeapp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M181.29,454.46c3.67,1.38,16.74,8.28,16,11.92s-18.94,3.74-28.49,1.38-9.7-1.75-13.37-2.15-9.38-6.05-1.06-14.83a39.16,39.16,0,0,0,14.92,4A64.93,64.93,0,0,0,181.29,454.46Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M161,455a6.05,6.05,0,0,1-4.06-3.09c-1.61-.65-2.56-1.16-2.56-1.16-8.32,8.78-2.61,14.42,1.06,14.83s3.83-.22,13.37,2.15a71.89,71.89,0,0,0,20.09,1.42C180.32,463,171.28,457.67,161,455Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M170,439.92c-.73.21-1.71,7.3-1.71,7.3s10.77,5.92,13,7.24-7.89,7.4-14.68,6c-3.42-.72-12.48-2.74-13.45-5.39s4.4-8.57,3.17-14.58Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M129.33,311.16c-1.22,19.95,5.1,27.43,11.44,47.37,2.33,7.32,10.84,25.86,13.06,36.2,3.83,17.83.19,46-.33,51.15,0,0,8,4.38,16.12,1.85,0,0,7-23.68,5.88-64.83-1.23-45.71-7.76-74.4-7.76-74.4Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M153.83,394.73c1.89,8.8,2,20.13,1.48,30,9.69-21.94,17-44.62,18.8-68.54-2.33-29.87-6.37-47.66-6.37-47.66l-38.41,2.66c-1.22,19.95,5.1,27.43,11.44,47.37C143.1,365.85,151.61,384.39,153.83,394.73Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M155,457.63c3.67,1.38,16.74,8.27,16,11.91s-18.95,3.75-28.49,1.38-9.7-1.75-13.37-2.15-9.38-6-1.06-14.82a39.37,39.37,0,0,0,14.92,4A64.93,64.93,0,0,0,155,457.63Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M141.08,443.08c-.73.22,1,7.31,1,7.31s10.77,5.92,13,7.24-7.89,7.4-14.68,6c-3.42-.72-12.48-2.74-13.46-5.39s1.72-8.57.49-14.58Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M121.09,316.69c-1.22,19.95,5.09,27.43,11.44,47.37,2.33,7.32,0,27.39,0,38-.07,19-6.56,41-7.08,46.12,0,0,8,4.38,16.12,1.85,0,0,14.92-32.53,18.15-70.57,2.3-27.2-.23-65.41-.23-65.41Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M336.47,469.26h-122A25.19,25.19,0,0,1,189,442l19.53-297.46a29.51,29.51,0,0,1,29-27.23h122A25.19,25.19,0,0,1,385,144.57L365.49,442A29.51,29.51,0,0,1,336.47,469.26Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M332.21,469.26h-122A25.18,25.18,0,0,1,184.75,442l19.52-297.46a29.51,29.51,0,0,1,29-27.23h122a25.18,25.18,0,0,1,25.44,27.23L361.23,442A29.5,29.5,0,0,1,332.21,469.26Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 272.75,
    cy: 442.5,
    rx: 14.77,
    ry: 13.83,
    transform: "translate(-232.47 314.69) rotate(-44.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M330,145.1H258.15a2.72,2.72,0,0,1-2.75-2.94h0a3.19,3.19,0,0,1,3.14-2.94h71.83a2.72,2.72,0,0,1,2.75,2.94h0A3.18,3.18,0,0,1,330,145.1Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M349.18,414.1H201.4a5.59,5.59,0,0,1-5.65-6.05l15.91-242.43a6.56,6.56,0,0,1,6.45-6.05H365.89a5.59,5.59,0,0,1,5.65,6.05L355.63,408.05A6.56,6.56,0,0,1,349.18,414.1Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M369.51,196.54l2-30.92a5.59,5.59,0,0,0-5.65-6.05H218.11a6.56,6.56,0,0,0-6.45,6.05l-2,30.92Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M208.76,209.91l-13,198.14a5.59,5.59,0,0,0,5.65,6.05H349.18a6.56,6.56,0,0,0,6.45-6.05l13-198.14Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M323.69,217H249.82a3.57,3.57,0,0,1-3.61-3.86h0a4.18,4.18,0,0,1,4.12-3.86H324.2a3.57,3.57,0,0,1,3.6,3.86h0A4.18,4.18,0,0,1,323.69,217Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M373.57,307.4l-9.06-16.24L350,282.41,343.63,280l1.78,3.21,4.38,3.85,5.58,7.47s3.17,7.1,5.61,8.5,8.61,9.79,8.61,9.79Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M451,336.31l-41.68-5.52L371.5,303.7l-7.85,4.37s23.19,31.45,34.92,37.84c11.47,6.25,53.15,14,53.15,14S469.21,345.13,451,336.31Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M383.45,313.25H230.68a5.1,5.1,0,0,1-5.15-5.51L228.6,261a6,6,0,0,1,5.87-5.51H387.24a5.1,5.1,0,0,1,5.15,5.51l-3.06,46.71A6,6,0,0,1,383.45,313.25Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M377.52,403.71H224.74a5.1,5.1,0,0,1-5.15-5.51l2.07-31.57a6,6,0,0,1,5.87-5.51H380.31a5.1,5.1,0,0,1,5.15,5.51l-2.07,31.57A6,6,0,0,1,377.52,403.71Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M288,355.84H225.54a2.93,2.93,0,0,1-3-3.17h0A3.43,3.43,0,0,1,226,349.5h62.43a2.93,2.93,0,0,1,3,3.17h0A3.43,3.43,0,0,1,288,355.84Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M381.67,344H255.13a4.47,4.47,0,0,1-4.52-4.83l.87-13.27a5.24,5.24,0,0,1,5.15-4.84H383.17a4.48,4.48,0,0,1,4.52,4.84l-.87,13.27A5.24,5.24,0,0,1,381.67,344Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M234.62,344h0a10.6,10.6,0,0,1-10.72-11.47h0a12.44,12.44,0,0,1,12.22-11.47h0a10.61,10.61,0,0,1,10.72,11.47h0A12.43,12.43,0,0,1,234.62,344Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 291.16,
    cy: 289.28,
    rx: 11.72,
    ry: 10.98,
    transform: "translate(-120.74 284.37) rotate(-44.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M166.7,205.11c-4.14,1.63-7.51,3.76-8.84,8s-3.88,12-3.88,12l-11.45-16.22s4.79-5.72,5.26-11.82c0,0,10-2.22,15.44-.58S166.7,205.11,166.7,205.11Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "217.24 239.29 221.43 230.63 225.56 226.58 230.85 226.43 230.06 230.62 217.24 239.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M241.17,225.64l.89,3.5s0,0,0,0l-23.43,6a.45.45,0,0,1-.53-.32l-.68-2.68a.44.44,0,0,1,.32-.53l23.43-5.94Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M238.64,226.73l.68,2.67h0l-23.05,5.85a.83.83,0,0,1-1-.6l-.27-1.07a.83.83,0,0,1,.6-1l23-5.85Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M247.08,226h0a.68.68,0,0,1-.49.82l-8.2,2.08a.67.67,0,0,1-.83-.49h0a.68.68,0,0,1,.49-.82l8.2-2.08A.68.68,0,0,1,247.08,226Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "239.68 226.15 240.56 229.64 244.36 227.67 243.95 226.07 239.68 226.15"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 230.79,
    y: 223.45,
    width: 1.01,
    height: 13.12,
    transform: "translate(63.77 511.3) rotate(-104.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M216.11,239.73s2.77-2.16,4.69-3.7,6.95-3.66,8.54-5.51c2.33-2.71,1.19-3.75,4-5.77,1.08-.79,4.51,1.1,4.51,1.1l-3.48,4,1.37,4-1,2.85c1,.92.06,4.85.06,4.85l-3.62,3.78S225,247.55,223,248s-8.86,3.73-8.86,3.73Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M331.06,279.8a7.32,7.32,0,0,0-10.34,0l-.13.13-.12-.13a7.31,7.31,0,0,0-10.34,10.34l10.43,10.43,0,0,0,0,10.43-10.43A7.3,7.3,0,0,0,331.06,279.8Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "210.64 241.6 216.02 238.85 217.19 253.88 202.97 255.12 210.64 241.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M153.5,170.2c3.39-2.7,11.22-3.67,16.06,5.61,4.32,8.27,9.16,14.56,6.88,24.41-1.75,7.59-6.66,8-18.44,3.68A26.23,26.23,0,0,1,142.66,189S149.12,173.68,153.5,170.2Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M169.79,180a1.57,1.57,0,1,1-1.94-1.09A1.58,1.58,0,0,1,169.79,180Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M172,192.29a5.85,5.85,0,0,0,4.28,1.11",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M171.12,180.62c2.17,2.75,4.33,4.27,6.5,7a1.1,1.1,0,0,1,.35.89c-.08.33-.42.51-.73.65l-3.46,1.55",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M132.05,225.74c-3,10-8.84,38.62-10.12,54.8-1,12.84-2.56,39-2.56,39s29.73,8.5,53.27.65c0,0-1.7-46.76-3-61.14s-.31-22.88-3.58-28.77-11.12-14.05-11.12-14.05l-12.42-7.52S134,219.2,132.05,225.74Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "141.01 208.15 159.38 219.97 154.97 230.27 138.1 212.01 141.01 208.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M136.79,232.76c5.71,10.22,30.4,25,36.29,30.4s30.82-6.81,41-6.53L213,240.21s-20.09,8.84-34.65,5.54c0,0-20-22.79-25.91-27.69S129,218.74,136.79,232.76Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M166.7,171.75s-4,3.52-8.22,7.1c-3.69,3.16-1,12.66-1.82,14.59,0,0-3-3-2.9-1.15.22,3.1,0,12.82,0,12.82s-5.63-2.26-11.1-3.83c-7.7-2.21-8.79-15.61-8.79-15.61v-5s-.21-6.3,6-12.29C150.28,158.29,169.85,163,166.7,171.75Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "126.82 180.93 127.68 187 132.37 186.17 132.37 181.12 126.82 180.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M128.32,180.43c-4.09-.06-6.08-4.63-15.43-1.58s-8,15.44-2.46,22.43,6.14,16,5.06,18.8a19.08,19.08,0,0,1-1.84,3.83s2.76.31,7.67-5.52,5.21-9.47,5.21-9.47a8.15,8.15,0,0,1,.77,4.21,13.61,13.61,0,0,0-.61-11c-2.92-6.11,2.49-15.62,2.49-15.62Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M152,191.09a11.85,11.85,0,0,1-1.49-1.67,2.6,2.6,0,0,0-1.9-1,2.5,2.5,0,0,0-2,1.93A5.51,5.51,0,0,0,149.8,197a10.66,10.66,0,0,0,4.06.34,1.35,1.35,0,0,0,1-.34,1.37,1.37,0,0,0,.08-1.24c-.25-.93-.39-3-1-3.72S152.65,191.59,152,191.09Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M164.33,169.69c-2.08,4-4.19,8-5.12,12.37s-.55,9.23,2,12.89",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M431.23,419.44s-34.05,19.06-47,26.38-11.48,17.82-11.42,21.69l92.34-.32-3.59-14.61s-33.6,6.64-43,8.85c0,0,29-3.31,43-8.85s19.89-12.32,19.89-12.32Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M470.06,450.34l17.48,1.05,9.45,31a27.1,27.1,0,0,1-12.23-3.86c-3.76-2.16-13.25-10.25-13.25-10.25Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "468.56 450.84 470.01 468.81 456.28 468.84 453.48 450.69 468.56 450.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M443.51,324.62a63.71,63.71,0,0,0,6,12.9l-18.58,8.15s-.82-12.2-8.4-17.79Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M424.09,302.18c-3.08-.56-5.27,3.13-7.46,4.63a7.09,7.09,0,0,1-2.94,1.32c-.69.14-1.91,0-2.22.87-.42,1.24,1.84,3,2,4.31.25,2.06-1.53,4.16-2,6.11-1.49,6.33,1.3,11.57,8.11,11.86,10.08.43,24.09-3.83,28.6-13.65,1.61-3.52,1.38-8.25.32-11.86-1.25-4.25-6.81-7.35-10.9-8.3a17.28,17.28,0,0,0-7.85.59c-2.18.57-5.47,1.18-7.23,2.63Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M419.55,305.82a1.42,1.42,0,0,0,2.54,1.27,1.42,1.42,0,1,0-2.54-1.27Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M452.19,303.7a6.13,6.13,0,0,0,1.8-6c-1.84-8.72-13.79-10.88-10.82-12.8a4,4,0,0,0-1.51,3.9.45.45,0,0,0,0,.11c-2.93-3.31-8-8.12-17.2-2.18-4.7,3.05-5.72,6.73-10.94,4.72.37.15-.42,2.53-.43,2.83a4.08,4.08,0,0,0,1.4,3.76c5.63,5.18,15.54,4.61,22.61,3.8,3.18-.36-1.76,3.06-3,5.12-.79,1.35-.29,7.06-.38,8.11,3.47.12,2.93-3,5.86-4.36,2.71-1.29,4.16,2.3,2.78,4.5-2.13,3.42-5.12,2.94-5.12,2.94-.47,2,3.7,6.06,3.9,8.14,2.09-.79,1.71.57,3.34-.36,1.22-.69,7.8-7.81,9.54-9.88C457.82,311.63,461.43,302.61,452.19,303.7Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M419.39,320.5c-2.21,1.14-4.85.3-6.66-1.23",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "442.11 326.81 425.16 342.88 431.5 352.89 445.45 329.15 442.11 326.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M447,328.66s9.69,4,16.32,11.73c31.14,36.33,18.17,99.87,18.17,99.87s-27.74,5.64-48.19-26L433,352.39Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M481.44,440.26,475.57,447c-9.6,11.09-38.72,13.81-50.21,4.69l-23.72-28.66,7.92,21.45-17.34,1.41S372,415.29,374.08,399.52c.38-2.84,3.58-9.84,7.59-9.17,23.38,3.9,59.83,20.85,59.83,20.85Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M414.74,453l4.15,14.19-47,1.11s3.32-5.8,5.94-7.49c3.63-2.35,20.28-6,20.28-6Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "413.25 453.5 394.78 457.08 388.96 447.16 407.42 441.51 413.25 453.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "358.65 311.45 359.7 302.76 358.55 297.63 354.57 294.92 353.12 298.51 358.65 311.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M350.26,276.7A11.67,11.67,0,0,0,342.39,297l-2.95,4.57,10.82-1.5a11.69,11.69,0,0,0,0-23.38Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M364.1,315.93a78.29,78.29,0,0,1-4.17-8.11c-.71-2.12-3.51-6.21-3.82-8.41a15.46,15.46,0,0,1,0-5l-2.69.86-.79,1.17-3,2.36-2.46,3.61a3.73,3.73,0,0,0-2.06,1.65l.9,4.67s5.06,5.82,6.38,7.17,4.94,7.22,4.94,7.22Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M446.26,342l-42.63,5.09-39.53-31.2-11.78,6.63s30.76,37.18,43.44,41.37c12.4,4.09,55.43,1.24,55.43,1.24S465.75,347.46,446.26,342Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-30",
    x1: 245.58,
    y1: 226.07,
    x2: 326.59,
    y2: 226.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-30",
    x1: 245.58,
    y1: 234.65,
    x2: 326.59,
    y2: 234.65
  })), /*#__PURE__*/React.createElement("g", {
    id: "rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    width: 600,
    height: 600
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomeapp);
export default __webpack_public_path__ + "static/media/customeapp.b0397ae03c8fab721d0d3e0c5a805fae.svg";
export { ForwardRef as ReactComponent };